import React from 'react'
import type { SelectInlineInputProps, SelectProps } from '@ztechapps/webui.input'
import { SelectInlineInput } from '@ztechapps/webui.input'
import { Select } from '@ztechapps/webui.input'
import map from 'lodash/map'
import { InventoryBySerialNumberStatus } from '@ztechapps/inventorybyserialnumber.common'

export const inventoryBySerialNumberStatusOptions = map(InventoryBySerialNumberStatus, (item) => {
  return { label: item.value, value: item.value }
})

export const InventoryBySerialNumberStatusSelect = ({ options, ...props }: SelectProps) => {
  return (
    <Select
      {...{
        ...props,
        options: options ?? inventoryBySerialNumberStatusOptions,
        isClearable: false,
      }}
    />
  )
}

export const InventoryBySerialNumberStatusSelectInlineInput = (props: SelectInlineInputProps) => {
  return (
    <SelectInlineInput
      {...props}
      selectComponent={InventoryBySerialNumberStatusSelect}
      selectOptions={inventoryBySerialNumberStatusOptions}
    />
  )
}
